import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {ICompetitor} from '../interfaces/ICompetitor';

export interface IFloatingMenuData {
  isShown: boolean;
  isLoading?: boolean;
  allItemsAmount?: number;
  isAllItemsSelected?: boolean;
  selectedCompetitors?: ICompetitor[];
}

export enum FloatingMenuActionsEnum {
  ACTIVATE_COMPETITORS,
  DEACTIVATE_COMPETITORS,
  SELECT_ALL_COMPETITORS,
  UNSELECT_ALL_COMPETITORS,
}

@Injectable({
  providedIn: 'root',
})
export class FloatingMenuService {
  floatingMenuState$: BehaviorSubject<IFloatingMenuData> = new BehaviorSubject<IFloatingMenuData>(null);
  floatingMenuActionEvent$: Subject<FloatingMenuActionsEnum> = new Subject<FloatingMenuActionsEnum>();

  constructor() { }
}
